import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { PosCreatePagesView } from './pages/pages';

export const PosCreateView = angular
  .module('acme.view.application.pos.create', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.directive.pos',
    'acme.common.directive.spectrum',
    'acme.view.application.pos.create.controllers',
    'acme.view.application.pos.create.description',
    'acme.view.application.pos.create.images',
    'acme.view.application.pos.create.navigation',
    PosCreatePagesView,
    'acme.view.application.pos.create.settings',
    'acme.view.application.pos.create.modals.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.pos.create',
      url: '/create',
      abstract: true,
      views: {
        'subview-main@application': {
          controller: 'PosCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/pos/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Point of Sale Configurator',
        pageClass: 'application application-pos-create',
        /** Secure With Permissions **/
        permissions: ['POS_CONFIG_CREATE'],
      },
      resolve: {
        spectrum: LoadScriptResolver({ id: 'spectrum-js', url: '/assets/spectrum.min.js' }),
        spectrumCss: LoadCssResolver({ id: 'spectrum', url: '/assets/spectrum.min.css' }),
      },
    });

    $stateProvider.state({
      name: 'application.pos.edit',
      url: '/:configId/edit',
      abstract: true,
      views: {
        'subview-main@application': {
          controller: 'PosCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/pos/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Point of Sale Configurator',
        pageClass: 'application application-pos-create',
        /** Secure With Permissions **/
        permissions: ['POS_CONFIG_UPDATE'],
      },
      resolve: {
        spectrum: LoadScriptResolver({ id: 'spectrum-js', url: '/assets/spectrum.min.js' }),
        spectrumCss: LoadCssResolver({ id: 'spectrum', url: '/assets/spectrum.min.css' }),
      },
    });
  }).name;
